import { required, helpers, maxLength } from '@vuelidate/validators'
import { useVuelidate } from '@vuelidate/core'
import ErrorList from './ErrorList'
import zipCityListGermany from '../../data/zipCityListGermany'
import SimpleTypeahead from 'vue3-simple-typeahead'
import { stepsConstants } from '../../data/steps'

const germany = 'Deutschland'

const zipValidationGermany = (value, siblings) => {
  if (siblings.country !== germany) {
    return true
  }

  const regex = /^[0-9]{5}$/
  return value.match(regex) !== null
}

const zipValidationOther = (value, siblings) => {
  if (siblings.country === germany) {
    return true
  }

  return value.length > 0 && value.length <= 10
}

const streetNumberValidation = (value) => {
    const firstCharValue = value.substring(0,1)
    return !isNaN(parseFloat(firstCharValue)) && isFinite(firstCharValue)
}

export default {
  props: ['formData', 'formOptions', 'formLabels'],
  components: {
    ErrorList,
    SimpleTypeahead
  },
  setup: () => {
    return {
      v$: useVuelidate(),
      zipCityListGermany
    }
  },
  methods: {
    itemProjectionFunction (item) {
      return item.title
    },
    selectItemFunction (item) {
      this.formData.zip = item.zipcode
      this.formData.city = item.city
      this.formData._zipCity = item.title
    },
    getDefaultZipCityItem () {
      if (this.formData.zip && this.formData.city) {
        const foundItem = zipCityListGermany.find(item => item.zipcode === this.formData.zip && item.city === this.formData.city)
        if (foundItem) {
          return foundItem.title
        }
      }
      return null
    },
    onCountryChanged (e) {
      if (e.target.value !== germany) {
        this.formData._zipCity = ''
        this.formData.zip = ''
        this.formData.city = ''
      }
    },
    setErrorId(fieldName) {
      const errors = this.v$.formData[fieldName].$errors
      return errors.length ? `errors--${fieldName}` : null
    }
  },
  validations () {
    return {
      formData: {
        street: {
          required: helpers.withMessage(stepsConstants.please_fill_field_correctly, required)
        },
        streetNumber: {
          required: helpers.withMessage(stepsConstants.please_fill_field_correctly, required),
          firstCharNumber: helpers.withMessage('Bitte geben Sie als erstes eine Ziffer an', streetNumberValidation),
        },
        addressAddition: {
          maxLength: helpers.withMessage('Dieses Feld darf nur eine maximale Länge von 40 Zeichen beinhalten.', maxLength(40))
        },
        country: {
          required: helpers.withMessage(stepsConstants.please_fill_field_correctly, required)
        },
        zip: {
          required: helpers.withMessage(stepsConstants.please_fill_field_correctly, required),
          zipGermany: helpers.withMessage('Bitte geben Sie die PLZ im richtigen Format ein, z.B. 12345.', zipValidationGermany),
          zipOthers: helpers.withMessage('Die PLZ darf maximal 10 Zeichen beinhalten', zipValidationOther)
        },
        _zipCity: {
          required: helpers.withMessage(stepsConstants.please_fill_field_correctly, (val, siblings) => (val && siblings.country === germany) || siblings.country !== germany),
          zipGermanyExists: helpers.withMessage('Bitte geben Sie eine valide PLZ ein.', (val, siblings) => {
            const zip = val.substring(0, val.indexOf(' '))
            const city = val.substring(val.indexOf(' ') + 1)

            if (siblings.country === germany) {
              return zip && city && zipCityListGermany.findIndex(item => item.zipcode === zip && item.city === city) !== -1
            }

            return true
          })
        },
        city: {
          required: helpers.withMessage(stepsConstants.please_fill_field_correctly, required)
        }
      }
    }
  },
  computed: {
    countryIsGermany () {
      return this.formData.country === germany
    },
    defaultZipCityItem: {
      cache: false,
      get: function () {
        if (this.formData.zip && this.formData.city) {
          return zipCityListGermany.find(item => item.zipcode === this.formData.zip && item.city === this.formData.city)
        }

        return null
      }

    }
  },
  template: `
    <div class="application__fieldset">
      <div class="application__fields__input-group application__fields__input-group--flex-3">
          <label for="street" class="form__label">{{formLabels['street']}}<span
                  class="form__mandatory">*</span></label>
          <input :aria-describedby="setErrorId('street')" type="text" v-model="formData.street" name="street" id="street" class="form__input" placeholder="" autocomplete="street-address" required>
          <p class="application__info-text">Angabe wie im Personalausweis</p>
          <error-list :errors="v$.formData.street.$errors" :id="setErrorId('street')"/>
      </div>
      
      <div class="application__fields__input-group application__fields__input-group--flex-1">
          <label for="street" class="form__label">{{formLabels['streetNumber']}}<span
                  class="form__mandatory">*</span></label>
          <input :aria-describedby="setErrorId('streetNumber')" type="text" v-model="formData.streetNumber" name="streetNumber" id="streetNumber" class="form__input" placeholder="" required>
          <p class="application__info-text">Bitte als Erstes eine Ziffer eingeben.</p>
          <error-list :errors="v$.formData.streetNumber.$errors" :id="setErrorId('streetNumber')"/>
      </div>
    </div>

    <div class="application__fields__input-group" style="--inputgroup-width:100%">
        <label for="addressAddition" class="form__label">{{formLabels['addressAddition']}}</label>
        <input :aria-describedby="setErrorId('addressAddition')" type="text" v-model="formData.addressAddition" autocomplete="address-line3" name="addressAddition" id="addressAddition" class="form__input" placeholder="">
        <error-list :errors="v$.formData.addressAddition.$errors" :id="setErrorId('addressAddition')"/>
    </div>

    <div class="application__fieldset">
        <div class="application__fields__input-group" style="--inputgroup-width:100%">
            <label class="form__label" for="country">{{formLabels['country']}}<span
                class="form__mandatory">*</span></label>
            <select :aria-describedby="setErrorId('country')" required name="country" v-model="formData.country" id="country" class="form__select form__select--no-replace" @change="onCountryChanged">
                <option value="" disabled selected>Bitte wählen Sie aus ...</option>
                <option v-for="text in formOptions.country" :key="text" :value="text">{{text}}</option>
            </select>
            <error-list :errors="v$.formData.country.$errors" :id="setErrorId('country')"/>
        </div>
    </div>
    
    <div class="application__fieldset" v-show="countryIsGermany">
        <div class="application__fields__input-group" style="--inputgroup-width:100%">
            <label for="_zipCity" class="form__label">{{formLabels['_zipCity']}}<span class="form__mandatory">*</span></label>
            <simple-typeahead 
                id="_zipCity" 
                placeholder="Geben Sie eine PLZ oder Stadt ein"
                ref="zipCityInput"
                autocomplete="postal-code"
                :items="zipCityListGermany"
                :itemProjection="itemProjectionFunction"
                @selectItem="selectItemFunction"
                :minInputLength="2" 
                class="form__input"
                :disabled="false"
                v-model="formData._zipCity"
                :value="formData._zipCity"
                :aria-describedby="setErrorId('_zipCity')"
                >
            </simple-typeahead>
            <p class="application__info-text">Angabe wie im Personalausweis</p>
            <error-list :errors="v$.formData._zipCity.$errors" :id="setErrorId('_zipCity')"/>
        </div>
    </div>
    
    <div class="application__fieldset" v-show="!countryIsGermany">
        <div class="application__fields__input-group" style="--inputgroup-width:30%">
            <label for="zip" class="form__label">{{formLabels['zip']}}<span class="form__mandatory">*</span></label>
            <input :aria-describedby="setErrorId('zip')" type="text" v-model="formData.zip" name="zip" id="zip" class="form__input" placeholder="" required>
        <error-list :errors="v$.formData.zip.$errors" :id="setErrorId('zip')"/>
        </div>

        <div class="application__fields__input-group" style="--inputgroup-width:70%">
            <label for="city" class="form__label">{{formLabels['city']}}<span class="form__mandatory">*</span></label>
            <input :aria-describedby="setErrorId('city')" type="text" v-model="formData.city" name="city" id="city" class="form__input" placeholder="" required>
            <error-list :errors="v$.formData.city.$errors" :id="setErrorId('city')"/>
        </div>
    </div>
    `
}
